'use strict';

let DateTimeDirective=require('../../../../../../dist-es6/client/directives/dateTimeDirective/dateTimeDirective');let

DateTimeForWaypointDirective=class DateTimeForWaypointDirective extends DateTimeDirective{
get templateUrl(){
return'/templates/features/scenario/directives/dateTimeForWaypoint/dateTimeForWaypointTemplate';
}};


module.exports=DateTimeForWaypointDirective;
//# sourceMappingURL=dateTimeForWaypointDirective.js.map
